<div class="middle-block" *ngIf="breakType === 'WORK'" [ngClass]="{'hide-block': showProjectsPage}">
	<div class="cards-block">
		<div class="cards-wrapper">
			<!-- <div class="card-label">
				PUNCH BUTTON
			</div> -->
			<div class="card-content">
				<div class="tab-block">
					<mat-tab-group *ngIf="(currentUser | async).trackWorkTime">
						<mat-tab label="DAY">
							<app-day-total class="card" (showProjects)="toggleProjectsPage()"></app-day-total>

							<div class="card">
								<div class="time-sheets-content">
									<app-timesheet [startPeriod]="startDay" [endPeriod]="startDay"></app-timesheet>
								</div>
							</div>
						</mat-tab>
						<mat-tab label="WEEK">
                            <app-pay-period class="card" [halfPeriod]="true">
                            </app-pay-period>
<!--							<div class="card">-->
<!--								<div class="card-label-block">-->
<!--									<div class="card-label">-->
<!--										{{startWeek | date: 'MMM d'}} - {{endWeek | date: 'MMM d'}}-->
<!--									</div>-->
<!--									<div class="card-total">-->
<!--										Total: {{weekTotalTimeStr}}-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="time-sheets-content">-->
<!--									<app-timesheet [startPeriod]="startWeek" [endPeriod]="endWeek"></app-timesheet>-->
<!--								</div>-->
<!--							</div>-->
						</mat-tab>
						<mat-tab label="PAY PERIOD">
							<app-pay-period class="card" [halfPeriod]="false">
							</app-pay-period>
						</mat-tab>
						<mat-tab label="PTO">
							<app-vacation-period class="card">
							</app-vacation-period>
						</mat-tab>
					</mat-tab-group>

					<app-vacation-period *ngIf="!(currentUser | async).trackWorkTime" class="card">
					</app-vacation-period>
				</div>
			</div>
		</div>

	</div>
</div>

<div class="middle-block" *ngIf="breakType !== 'WORK'">
	<app-break (showProjects)="toggleProjectsPage()"></app-break>
</div>



<app-choose-project *ngIf="showProjectsPage" (projectIsChoosen)="projectIsChoosen($event)">
</app-choose-project>